export default "/assets/b45d9997b704ab3daad1b5624eec1ad1.woff2";